import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M7 3m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z","key":"svg-1"}],["path",{"d":"M12 3v2","key":"svg-2"}],["path",{"d":"M10 15v.01","key":"svg-3"}],["path",{"d":"M10 18v.01","key":"svg-4"}],["path",{"d":"M14 18v.01","key":"svg-5"}],["path",{"d":"M14 15v.01","key":"svg-6"}]]

const IconDeviceRemote = createReactComponent('outline', 'device-remote', 'DeviceRemote', __iconNode);

export default IconDeviceRemote;